import UiBinder from "./modules/ui-binder.js";
import AjaxModal from "./modules/ajax-modal.js";
import InitNaja from "./modules/init/init-naja.js"
import InitNetteForms from "./modules/init/init-nette-forms.js";
import AjaxOverlay from "./modules/ajax-overlay.js";
import CtToast from "./modules/ct-toast.js";
import ErrorLogger from "./modules/error-logger.js";

const modules = [
	InitNetteForms,
	UiBinder,
	AjaxModal,
	AjaxOverlay,
	CtToast,
	//InitNaja musí být poslední
	InitNaja,
	ErrorLogger
];

modules.forEach(module => {
	if (typeof module.init === 'function') {
		module.init();
	}
});

